import {
  BasicInput,
  FormikAutocomplete,
  FormikCheckBox,
  FormikInputDate,
  FormikSelect,
  Row
} from '@elotech/components';
import { Option } from 'common/utils';
import { useEnsureProcessoIdEntity } from 'hooks/useEnsureProcessoIdEntity';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router';

import { ProcessoService, UsuarioService } from '../../service';
import {
  TipoRequerenteMpOptions,
  TipoRequeridoMpOptions,
  UsuarioLocalDTO
} from '../../types';

type Props = {
  local: any;
};

const ProcedimentoInternoSection: React.FC<Props> = ({ local }) => {
  const { location } = useHistory();
  const id = useEnsureProcessoIdEntity(location.search);
  const processoReferencia = location.state as any;
  const isEditing = useMemo(() => {
    return processoReferencia ? false : !!id;
  }, [id]);
  return (
    <>
      <Row>
        <FormikInputDate
          name="processoMp.dataAutuacao"
          label="Data Autuação"
          size={6}
        />
        <BasicInput name="processoMp.requerente" label="Requerente" size={4} />
        <FormikCheckBox
          size={2}
          name="processoMp.requerenteSigiloso"
          label="Requerente Sigiloso"
          disabled={isEditing}
        />
      </Row>
      <Row>
        <FormikSelect<Option>
          name="processoMp.tipoRequerido"
          label="Tipo Requerido"
          options={TipoRequeridoMpOptions}
          size={6}
          getOptionLabel={obj => obj.description}
          getOptionValue={obj => obj.value}
        />
        <BasicInput name="processoMp.requerido" label="Requerido" size={6} />
      </Row>
      <Row>
        <FormikAutocomplete<UsuarioLocalDTO>
          size={6}
          fast={false}
          name="processoMp.distribuicao"
          label="Distribuição"
          disabled={!local}
          getOptionLabel={u => u.nomeUsuario}
          onSearch={search =>
            UsuarioService.findAllUsuarioEntidadeAtualAutoComplete(search)
          }
        />
      </Row>
      <Row>
        <FormikAutocomplete
          name="procedimentoOrigem"
          label="Procedimento Origem"
          size={6}
          onSearch={ProcessoService.findAllAutocomplete}
          getOptionLabel={(p: any) =>
            `Tipo:${p.tipo?.descricao} - Número:${p.numero} - Ano:${p.ano}`
          }
        />
        <FormikSelect<Option>
          name="processoMp.tipoRequerente"
          label="Tipo Requerente"
          options={TipoRequerenteMpOptions}
          size={6}
          getOptionLabel={obj => obj.description}
          getOptionValue={obj => obj.value}
        />
      </Row>
    </>
  );
};

export default ProcedimentoInternoSection;
